/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserUpdateRequest {
    getFixupPrototypeFunction() { return UserUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<UserUpdateRequest>): UserUpdateRequest {
        let obj = Object.assign(new UserUpdateRequest(), model);
        UserUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserUpdateRequest>): UserUpdateRequest {
        if (!model) return null;
        return UserUpdateRequest.newInstance(<UserUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserUpdateRequest) {
        if (!obj) return;

        models.UserUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserUpdateRequest): boolean {
        Object.setPrototypeOf(obj, UserUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.role_assignment) {
            for (let val of this.role_assignment) {
                models.UpdateRoleAssignment.fixupPrototype(val);
            }
        }
    }

    /**
     * Email ID of the user. This wil be unique across all the CoreStack accounts
     */
    email: string;

    /**
     * First Name of the user. It can be only alphanumeric
     */
    first_name: string;

    /**
     * Last Name of the user. It can be only alphanumeric
     */
    last_name: string;

    /**
     * ID of the timezone to be set for th user. For a valid list of timezone values to use, please refer https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
     */
    timezone_id: string;

    /**
     * List of roles assignments for the user. The same user can be assigned different roles in different tenants
     */
    role_assignment: Array<models.UpdateRoleAssignment>;

    /**
     * Mobile number of the user.
     */
    mobile: string;

    /**
     * Preferred language of the user.
     */
    preferred_language: models.PreferredLanguage;

    /**
     * Preferred UI theme of the user, such as light or dark. An empty value clears it.
     */
    preferred_theme: string;

}
